import {
  BIZ_MODEL_HINT,
  ENTRY,
  ENTRY_PATH,
  EXPERIENCE,
  PRODUCT_FAMILY,
} from '@/constants/od-session-context'
import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

export function getEntryPath() {
  const { onboardingContext } =
    getCommonsNorthboundAPIs().v1.store.state.onboarding.sessionContext

  if (onboardingContext.entry === ENTRY.STARTSCAN) return ENTRY_PATH.STARTSCAN
  if (
    onboardingContext.experience === EXPERIENCE.SMB &&
    onboardingContext.bizModelHint === BIZ_MODEL_HINT.E2E
  )
    return ENTRY_PATH.ACTIVATE
  if (
    onboardingContext.experience === EXPERIENCE.SMB &&
    onboardingContext.bizModelHint === BIZ_MODEL_HINT.FLEX &&
    onboardingContext?.productFamily !== PRODUCT_FAMILY.LFP
  )
    return ENTRY_PATH.CONNECT
  if (
    onboardingContext.experience === EXPERIENCE.SMB &&
    onboardingContext.bizModelHint === BIZ_MODEL_HINT.FLEX &&
    onboardingContext?.productFamily === PRODUCT_FAMILY.LFP
  )
    return ENTRY_PATH.GO
  if (onboardingContext.experience === EXPERIENCE.ECP) return ENTRY_PATH.PN
}
